// Central konfiguration för förbeställning och bordsbokning.
// Uppdatera värdena här när något ändras.

export const CONTACT_EMAIL = 'info@lillaverket.se'

// Förbeställning gäller mackor och våra signaturprodukter.
export type PreorderItem = {
  name: string
  ingredients: string
  image?: { src: string; alt: string; zoom?: number; focus?: string }
}

export type PreorderGroup = {
  title: string
  note?: string
  items: PreorderItem[]
}

export const PREORDER_GROUPS: PreorderGroup[] = [
  {
    title: 'Mackor',
    items: [
      {
        name: 'Beet & Bleat',
        ingredients:
          'Chèvre, rödbeta, marinerad grönkål, rödkål, valnötter, chilihonung',
        image: {
          src: 'https://cdn.magicpatterns.com/uploads/27RGErwjRfq1sQK4Qk2X2B/4.png',
          alt: 'Beet & Bleat',
        },
      },
      {
        name: 'Bee & Brie',
        ingredients: 'Brie, salami, mascarpone, olivröra, fänkål, chilihonung',
        image: {
          src: 'https://cdn.magicpatterns.com/uploads/u35Yd8CjWfK3R4kLB5XoSh/5.png',
          alt: 'Bee & Brie',
        },
      },
      {
        name: 'Fig & Pig',
        ingredients:
          'Taleggio, prosciutto, chèvrekräm, sockerärts- & majsröra, sallad, fikon',
        image: {
          src: 'https://cdn.magicpatterns.com/uploads/nPP3FAmZ6XFasAgSBgW3yM/6.png',
          alt: 'Fig & Pig',
        },
      },
      {
        name: 'Tuna Matata',
        ingredients:
          'Krämig tonfiskröra, spenat, syltlök, bifftomat, dill, salladslök, citron',
        image: {
          src: 'https://cdn.magicpatterns.com/uploads/bp9CpVUnut7DYTyE5iNtEi/7.png',
          alt: 'Tuna Matata',
        },
      },
    ],
  },
  {
    title: 'LV Signaturverk',
    note: 'Basque Cheesecake beställs som hel kaka eller bit — skriv önskemål i Övrigt.',
    items: [
      {
        name: 'Basque Cheesecake',
        ingredients:
          'Vår brända cheesecake — krämig mitt, mörk yta. Hel kaka eller bit.',
        image: {
          src: 'https://cdn.magicpatterns.com/uploads/3RYC93pccXN5XDyS56ph5C/IMG_0592.png',
          alt: 'Basque cheesecake med bränd yta och krämig mitt',
          zoom: 1.2,
          focus: 'center 60%',
        },
      },
      {
        name: 'Pain au Chocolat',
        ingredients: 'Smörig jästdeg med mörk choklad, bakad på plats.',
        image: {
          src: 'https://cdn.magicpatterns.com/uploads/7fG35a1VbtM3NctqvUiKYf/35677327-8D71-4B0C-8305-E02C836CAB8C_2.png',
          alt: 'Pain au chocolat med smöriga lager',
          zoom: 1.5,
          focus: '35% 60%',
        },
      },
      {
        name: 'Cookies',
        ingredients: 'Dagens cookies — choklad eller matcha med hallon.',
        image: {
          src: 'https://cdn.magicpatterns.com/uploads/7M6pwwh1qBWMmRLtT94dzD/IMG_8838.png',
          alt: 'Cookies i choklad och matcha med frystorkade hallon',
        },
      },
      {
        name: 'Brownie',
        ingredients:
          'Brownie med mascarponefyllning, toppad med mango & passionsfrukt.',
        image: {
          src: 'https://cdn.magicpatterns.com/uploads/fwrn8gquAUvT8w9W5BxGQe/IMG_3640.png',
          alt: 'Brownie med mascarponefyllning och mangocurd',
          zoom: 1.7,
          focus: 'center 60%',
        },
      },
    ],
  },
]

// Platt lista över allt som går att förbeställa.
export const PREORDER_ITEMS: PreorderItem[] = PREORDER_GROUPS.flatMap(
  (group) => group.items,
)

export const PAYMENT_OPTIONS = [
  { value: 'Faktura', label: 'Faktura' },
  { value: 'Betalning på plats', label: 'Betalning på plats' },
] as const

// Vinkvällar hålls torsdag–lördag. index följer JS getDay(): sön = 0.
export const WINE_NIGHTS = [
  { name: 'Torsdag', index: 4 },
  { name: 'Fredag', index: 5 },
  { name: 'Lördag', index: 6 },
] as const

// Totalt antal sittplatser per vinkväll. Fler gäster än så hamnar på väntelista.
export const SEATS_TOTAL = 20

// Redan bokade platser per kväll — uppdatera manuellt för att styra väntelistan.
export const BOOKED_SEATS: Record<string, number> = {
  Torsdag: 0,
  Fredag: 0,
  Lördag: 0,
}
